import React, { lazy, Suspense } from 'react';

const LazyGenerateSidesSuccess = lazy(async () => await import('./GenerateSidesSuccess'));

const GenerateSidesSuccess = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazyGenerateSidesSuccess {...props} />
  </Suspense>
);

export default GenerateSidesSuccess;
